<template>
    <div class="new-category-form">
      <p class="title">{{editItem ? 'Edit' : 'Add New'}}</p>
        <form v-on:submit.prevent="editSetting">
            <div class="label required">Category</div>
            <div class="input-ctn">
                <input type="text" v-model="categoryLabel" placeholder="Category" onkeydown="event.preventDefault()" class="input" @focus="openCategoryModal">
            </div>

            <div class="label">Order</div>
            <div class="input-ctn">
                <input type="number" min="0" v-model="order" placeholder="Order" class="input"
                    oninput="validity.valid||(value='');">
            </div>

            <button class="btn submit">Save</button>
        </form>
        <SelectCategoryModal
            :closeModal="closeCategoryModal"
            v-show="categoryModalOpened"
            :onSubmit="selectedCategory"
        />
    </div>
  </template>
  
  <script>
    import SelectCategoryModal from "../../components/SelectCategoryModal";
    
    export default {
        name: "NewCategory",
        components: {
            SelectCategoryModal
        },
        props: ['addNewSuccess', 'editItem'],
        data() {
            return {
                id: this.editItem?._id,
                categoryId: this.editItem?.category?._id,
                categoryLabel: this.editItem?.category?.en,
                order: this.editItem?.order || 20,
                isLoading: true,
                categoryModalOpened: false,
            }

        },
        methods: {
            async editSetting() {
                if(!this.categoryId && !this.category) {
                    alert('Please select category');
                    return;
                }
                this.isLoading = true

                const success = await this.$store.dispatch(this.id ? 'updateSettingHomepageCategory' :
                    'createSettingHomepageCategory', {
                        _id: this.id,
                        categoryId: this.category?._id || this.categoryId,
                        categoryName: this.category?.en || '',
                        order: this.order
                    })
                if (success) {
                    alert("Successfully");
                    this.addNewSuccess();
                }
                this.isLoading = false
            },
            openCategoryModal() {
                this.categoryModalOpened = true;
                setTimeout(() => {
                    document.getElementById("selectCategoryModelSearchInput").focus();
                })
            },
            closeCategoryModal() {
                this.categoryModalOpened = false;
            },
            selectedCategory(category) {
                if(this.category == category) {
                    return;
                }

                if(category) {
                    this.categoryLabel = category.en;
                } else {
                    this.categoryLabel = null;
                }
                this.category = category;
            },
        }

    }
  </script>
  
  <style>
  
  </style>